/**
 * Fitting Box Vue Component
**/

import { getFittingBoxApiKey } from '../utils/api.js';
import { trackVtoClick } from '../utils/helpers.js';
const FITTINGBOX_API_KEY = getFittingBoxApiKey();

export const fittingBox = {
    data() {
        return {
            // FittingBox
            virtualTryOn: {
                visible: false,
                ready: false,
                instance: null
            }
        }
    },
    methods: {
        // Load the library 
        _initTryOn() {
            var script = document.createElement("script");
            script.setAttribute("src", 'https://vto-advanced-integration-api.fittingbox.com/index.js');
            script.setAttribute("type", "text/javascript");
            document.head.appendChild(script);
        },

        // Managing fitting box methods
        async _fittingBoxController(create = false, remove = false, update = false, glassesID) {
            let hasBeenInitalized = !!this.virtualTryOn.instance && !!window.FitMix;

            const params = {
                apiKey: FITTINGBOX_API_KEY,
                onStopVto: () => { 
                    this.virtualTryOn.ready = false; 
                    this.virtualTryOn.instance = null; 
                    this.virtualTryOn.visible = false;
                }
            }
            
            if (create) {
                if (!!hasBeenInitalized) {
                    this.virtualTryOn.instance = FitMix.createWidget('fitmix-container', params, () => { 
                        this.virtualTryOn.ready = true;  
                        this.virtualTryOn.instance.setFrame(glassesID);   
                        this._startVTO() 
                    });
                } else if (!hasBeenInitalized) {
                    this._initTryOn();
                    this.virtualTryOn.instance = FitMix.createWidget('fitmix-container', params, () => { 
                        this.virtualTryOn.ready = true;  
                        this.virtualTryOn.instance.setFrame(glassesID);    
                        this._startVTO()
                    });
                }
            } 
            if (remove && !!hasBeenInitalized) {
                this._stopVTO()
            }
            if (update && !!hasBeenInitalized) {
                this.virtualTryOn.instance.setFrame(glassesID);
                this.virtualTryOn.instance.restartVto();
            }
        },

        _stopVTO () {
            this.virtualTryOn.instance.stopVto()
        },

        _startVTO() {
            this.virtualTryOn.instance.startVto('live')
        },

        // Toggle the VR Try On
        toggleTryOn(glassesID, location) {
            if (this.virtualTryOn.visible) {
                this._fittingBoxController(false, true, false);
            } else {
                // Track VTO Click
                trackVtoClick({
                    glasses_id: glassesID,
                    cta_location: location
                });

                this.virtualTryOn.visible = true;
                this.$nextTick( () => this._fittingBoxController(true, false, false, glassesID));
            }
        }
    }
};